export function hmsaFilter() {
  function filter(input) {
    // input format : PT(-)00H(-)00M(-)00S
    if(input === "") return "";

    const isNegative = input.indexOf('-') !== -1;
    const withoutMinus = input.replace(/-/g, '');
    const formatted = (isNegative ? '-' : '') + withoutMinus;

    // formatted format: (-)PT00H00M00S
    var h = "00";
    var min = "00";
    var sek = "00";
    var time = "";
    var minus = "";
    if(formatted[0] == "-"){
      time = formatted.slice(3); // removing -PT
      minus = "-";
    } else {
      time = formatted.slice(2); //removing PT
    }

    if(time.indexOf("H") !== -1) {
      h = time.substring(0, time.indexOf("H"));
      time = time.slice(time.indexOf("H") + 1);
    }

    if(time.indexOf("M") !== -1) {
      min = time.substring(0, time.indexOf("M"));
      time = time.slice(time.indexOf("M") + 1);
    }

    if(time.indexOf("S") !== -1) {
      sek = time.substring(0, time.indexOf("S"));
    }

    sek = Math.floor(parseFloat(sek)).toString();

    if(sek == 60) {
      sek = "00";
      min= (parseInt(min) + 1).toString();
    }
    if(min == 60)
    {
      h = (parseInt(h) + 1).toString();
      min = "00";
    }

    if(h.length == 1){
      h="0"+h;
    }
    if(min.length == 1){
      min="0"+min;
    }
    if(sek.length == 1){
      sek="0"+sek;
    }
    return `${minus}${h}:${min}:${sek}`;
  }
  return filter;
}

